import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { IBehaelter } from '../_interfaces/behaelter';

import { BehaelterService } from '../_services/behaelter.service';

@Pipe({
  name: 'behaelter'
})
export class BehaelterPipe implements PipeTransform {
  constructor(
    private behaelterService: BehaelterService,
  ) { }

  transform(value: unknown, ...args: unknown[]): unknown {
    //console.log("BehaelterPipe.transform() value: ", value);
    if(value == null) return of('');

    return this.behaelterService.getBehaelter(value as number)
    .pipe(
      map((behaelter: IBehaelter) => {
        //console.log("BehaelterPipe.transform(): behaelter:", behaelter);
        // Achtung: Behälter kommt ohne Summary!
        //return behaelter.behaelterNummer + " " + behaelter.hersteller + " " + behaelter.baujahr;
        return this.behaelterService.buildSummary(behaelter);
      })
      , catchError(error => {
        console.error("BehaelterPipe.transform()error: ", error);
        return of('');
      })
    );

  }

}
